import { useEffect, useState } from 'react'
import { attachmentsApi, type AttachmentResponse } from '@/api/endpoints/attachments'
import { useUI } from '@/stores/ui'

/** Download buttons for an event's / message's attachments (everyone who can see the item can download). */
export default function AttachmentLinks({ ids }: { ids?: string[] | null }) {
  const addToast = useUI((s) => s.addToast)
  const [items, setItems] = useState<AttachmentResponse[]>([])

  useEffect(() => {
    let mounted = true
    if (!ids?.length) { setItems([]); return }
    Promise.all(ids.map((id) => attachmentsApi.get(id).catch(() => null))).then((rows) => {
      if (mounted) setItems(rows.filter(Boolean) as AttachmentResponse[])
    })
    return () => { mounted = false }
  }, [ids?.join(',')])

  if (!items.length) return null
  return (
    <div className="flex flex-wrap gap-2 mt-1">
      {items.map((a) => {
        const name = a.original_filename || a.filename
        return (
          <button
            key={a.id}
            type="button"
            className="text-xs px-2 py-1 rounded border border-gray-300 bg-white hover:bg-yellow-50 focus-ring"
            title={`Download ${name}`}
            onClick={async (e) => {
              e.stopPropagation()
              try { await attachmentsApi.download(a.id, name) }
              catch { addToast({ message: `Could not download ${name}`, type: 'error' }) }
            }}
          >
            📎 {name}
          </button>
        )
      })}
    </div>
  )
}
